import React, { useEffect, useState } from "react";
import { Box, Grid2, styled, Tab, Tabs, Typography, Card, Grid, useTheme } from "@mui/material";
import ProgressKPI from "./Schedule/ProgressKPI";
import VarianceTable from "./Schedule/VarianceTable";
import PlanActualGraph from "./Schedule/PlanActualGraph";
import archiveImg from "assets/icons/archive.svg";
import activeArchiveImg from "assets/icons/activeArchive.svg";
import SchedulePerformanceIndex from "./Schedule/SchedulePerformanceIndex";
import ScurveChart from "./Schedule/ScurveChart";
import Milestone from "./MileStone";
import ProgressKPIEngg from "./engineering/ProgressKPIEngg";
import ScurveEngg from "./engineering/ScurveEngg";
import PlanActualEngg from "./engineering/PlanActualEngg";
import EngineeringDepartment from "./engineering/EngineeringDepartment";
import SubTabs from "components/SubTabs";
import subTabsItems from "components/subTabs-items";
import ProgressKpiConstruction from "./construction/ProgessKpiConstruction";
import PlanVsActualConstruction from "./construction/PlanVsActualConstruction";
import ScurveConstruction from "./construction/ScurveConstruction";
import ProgressKpiPM from "./p&m/ProgressKpiPM";
import EquipmentOwnedHired from "./p&m/EquipmentOwnedHired";
import MachineRunHours from "./p&m/MachineRunHours";
import MachineStatus from "./p&m/MachineStatus";
import DeployedEquimentList from "./p&m/DeployedEquipmentList";
import UpcomingEquipmentDeployment from "./p&m/UpcomingEquipmentDeployment";
import ApprovalWorkflowBottleneck from "./engineering/ApprovalWorkflowBottleneck";
import DocumentStatusBreakdown from "./engineering/DocumentStatusBreakdown";
import DistributionofDocumentStatusByDepartment from "./engineering/DistributionofDocumentStatusByDepartment";
import ManpowerPlanActual from "./ManpowerAndProductivity/ManpowerPlanActual";
import ManpowerShortfall from "./ManpowerAndProductivity/ManpowerShortfall";
import UpcomgManpowerRequirement from "./ManpowerAndProductivity/UpcomgManpowerRequirement";
import ManpowerHistogram from "./ManpowerAndProductivity/ManpowerHistogram";
import ManpowerProductivity from "./ManpowerAndProductivity/ManpowerProductivity";
import ConstuctionVarianceTable from "./construction/ConstuctionVarianceTable";
import ProjectDuration from "./Schedule/ProjectDuration";
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge';
import SchedulePerformanceIndexEng from "./engineering/schedulePerformanceIndicaror";
import Schedule from "./Schedule/Schedule";
import PlanActualProcurement from "./construction/PlanActualProcurement";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";




// const StyledSubTab = styled(Tab)(({ theme }) => ({
//     textTransform: "none", // Prevent uppercase
//     fontWeight: "400",
//     fontSize: "16px",
//     color: "#474747",
//     padding: '0px',
//     minHeight: '0px',
//     minWidth: '0px',
//     padding: '5px 20px 5px 20px',
//     lineHeight: '24px',
//     borderRadius: '4px',
//     // letterSpacing:'-0.4px',
//     backgroundColor: '#F3F3F3',
//     "&.Mui-selected": {
//         color: "#fff",
//         // borderRadius: '10px',
//         backgroundColor: ${theme?.customSettings?.themeColor},
//         // padding: '6px'
//     }
// }));

// const subTabs = [
//     { label: "Construction", path: "construction", index: 0 },
//     { label: "Schedule", path: "schedule", index: 1 },
//     { label: "Milestone", path: "milestone", index: 2 },
//     { label: "Engineering", path: "engineering", index: 3 },
//     { label: "P&M", path: "pm", index: 4 },
//     { label: "Manpower", path: "manpower", index: 5 },
//     { label: "Productivity", path: "productivity", index: 6 },


// ];

const cardsData = [
    {
        value: 112,
        change: '+3.4%',
        timeFrame: 'in 30 days',
        label: 'Total Cricitical Activities',

        color: '#CDFBE7',
        changeColor: '#1E8E3E',
    },
    {
        value: 103,
        change: '+3.4%',
        timeFrame: 'in 30 days',
        label: 'Delay in Days',

        color: '#CDFBE7',
        changeColor: '#1E8E3E',
    },
    {
        value: 65,
        change: '+3.4%',
        timeFrame: 'in 30 days',
        label: 'Critical Activity Variance',

        color: '#CDFBE7',
        changeColor: '#1E8E3E',
    },
    {
        value: '48.15%',
        change: '+3.4%',
        timeFrame: 'in 30 days',
        label: 'Schedule Variance',

        color: '#CDFBE7',
        changeColor: '#1E8E3E',
    },

    // Add 4 more cards as needed
];

const card = [
    {
        value: '27 March, 2025',
        label: 'Forcast completion Date',
        color: '#CDFBE7',
        changeColor: '#D32F2F',
    },
    {
        value: '12 February, 2025',

        label: 'Planned Complition Date',

        color: '#CDFBE7',
        changeColo: '#CDFBE7',
    },

]



const tableData = [
    {
        id: "01",
        activities: "Excavation Completion",
        baseline: "03 May, 2024",
        forcast: "04 May, 2024",
        variance: "01",
        cat: "01",
        sub1: "01",
        sub2: "01",
    },
    {
        id: "01",
        activities: "Excavation Completion",
        baseline: "03 May, 2024",
        forcast: "04 May, 2024",
        variance: "01",
        cat: "01",
        sub1: "01",
        sub2: "01",
    },
    {
        id: "01",
        activities: "Excavation Completion",
        baseline: "03 May, 2024",
        forcast: "04 May, 2024",
        variance: "01",
        cat: "01",
        sub1: "01",
        sub2: "01",
    },
    {
        id: "01",
        activities: "Excavation Completion",
        baseline: "03 May, 2024",
        forcast: "04 May, 2024",
        variance: "01",
        cat: "01",
        sub1: "01",
        sub2: "01",
    },
    {
        id: "01",
        activities: "Excavation Completion",
        baseline: "03 May, 2024",
        forcast: "04 May, 2024",
        variance: "01",
        cat: "01",
        sub1: "01",
        sub2: "01",
    },
];



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

// function a11yProps(index: number) {
//     return {
//         id: simple-tab-${index},
//         'aria-controls': simple-tabpanel-${index},
//     };
// }
const ScheduleMonitoringTracking = () => {
    const theme = useTheme();
    // const [value, setValue] = useState(Number(localStorage.getItem("scheduleTabIndex")) || 0);

    const { hasPermission } = useCheckMenuPermission();

    const [value, setValue] = useState(null);

    useEffect(() => {
        const storedIndex = localStorage.getItem("scheduleTabIndex");
        if (storedIndex !== null) {
            setValue(Number(storedIndex));
        } else {
            const firstPermittedTab = subTabsItems?.scheduleSubTabs?.find(item =>
                hasPermission([item?.permissionKey])
            );
            if (firstPermittedTab != undefined) {
                localStorage.setItem("scheduleTabIndex", firstPermittedTab.index ?? 0);
                setValue(firstPermittedTab?.index ?? 0)
            }
        }
    }, [hasPermission, subTabsItems]);

    const handleChange = (newIndex) => {
        setValue(newIndex);
        localStorage.setItem("scheduleTabIndex", newIndex);
    };


    // const [selectTab, setSelectTab] = useState(0);
    // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    //     setValue(newValue);
    // };
    return (
        <>
            <SubTabs subTabs={subTabsItems?.scheduleSubTabs} selectedTab={handleChange} selectedIndex={value} variant={"scrollable"} />
            {/* <Tabs value={value} onChange={handleChange} aria-label="icon tabs example" variant="fullWidth"
                sx={{
                    mt: 1,
                    minHeight: '0px',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    "& .MuiTabs-indicator": {
                        height: '0px'
                    },
                    "& .MuiTab-root": {
                        margin: "5px 3px 5px 3px",
                        "&:first-of-type": {
                            marginLeft: '6px',
                        },
                        "&:last-of-type": {
                            marginRight: '6px',
                        },
                    },
                }}
            >
                <StyledSubTab label="Construction" {...a11yProps(0)} iconPosition="start" icon={<img src={value == 0 ? activeArchiveImg : archiveImg} alt="construction" style={{ width: '16px', height: '16px' }} />} aria-label="construction" />
                <StyledSubTab label="Schedule" {...a11yProps(1)} iconPosition="start" icon={<img src={value == 1 ? activeArchiveImg : archiveImg} alt="schedule" style={{ width: '16px', height: '16px' }} />} aria-label="schedule" />
                <StyledSubTab label="Milestone" {...a11yProps(2)} iconPosition="start" icon={<img src={value == 2 ? activeArchiveImg : archiveImg} alt="milestone" style={{ width: '16px', height: '16px' }} />} aria-label="milestone" />
                <StyledSubTab label="Engineering" {...a11yProps(3)} iconPosition="start" icon={<img src={value == 3 ? activeArchiveImg : archiveImg} alt="engineering" style={{ width: '16px', height: '16px' }} />} aria-label="engineering" />
                <StyledSubTab label="P&M" {...a11yProps(4)} iconPosition="start" icon={<img src={value == 4 ? activeArchiveImg : archiveImg} alt="p&m" style={{ width: '16px', height: '16px' }} />} aria-label="p&m" />
                <StyledSubTab label="Manpower" {...a11yProps(5)} iconPosition="start" icon={<img src={value == 5 ? activeArchiveImg : archiveImg} alt="manpower" style={{ width: '16px', height: '16px' }} />} aria-label="manpower" />
                <StyledSubTab label="Productivity" {...a11yProps(6)} iconPosition="start" icon={<img src={value == 6 ? activeArchiveImg : archiveImg} alt="productivity" style={{ width: '16px', height: '16px' }} />} aria-label="productivity" />
            </Tabs> */}


            <CustomTabPanel value={value} index={1}>
                <Grid2 container spacing={1} sx={{ mt: 2 }}>
                    <ProgressKpiConstruction />
                </Grid2>
                <Grid2 container spacing={1.25} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <Card sx={{ boxShadow: 'none', borderRadius: 2, height: '100%', border: "1px solid #D8D8D8" }}>
                            <ScurveConstruction />
                        </Card>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <PlanVsActualConstruction />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "600px" }}>
                        <PlanActualProcurement />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                        <ConstuctionVarianceTable />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={0}>
                <ProgressKPI />
                <Grid2 container columnSpacing={1.25} rowSpacing={{ xs: 2, md: 0 }} sx={{ mt: "10px", }}>
                    <Grid2 size={{ xs: 12, md: 5 }}>
                        <Card sx={{ boxShadow: 'none', borderRadius: 2, height: '100%', border: "1px solid #D8D8D8" }}>
                            <ScurveChart />
                        </Card>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 7, lg: 7 }}>
                        <Grid2 container spacing={1.25} rowSpacing={{ xs: 2, md: 1.25 }} >
                            <Grid2 size={{ xs: 12, md: 6, lg: 6, }}>
                                <PlanActualGraph />
                            </Grid2>

                            <Grid2 size={{ xs: 12, md: 6, lg: 6, }}>
                                <SchedulePerformanceIndex />
                            </Grid2>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 12 }} sx={{ mt: { xs: 2, md: "12px" } }}>
                            <ProjectDuration />
                        </Grid2>
                    </Grid2>
                    {/* <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                            <Schedule />
                    </Grid2> */}
                </Grid2>
                <Box sx={{ mt: { xs: 2, md: 3 } }}>
                    <VarianceTable data={tableData} />
                </Box>
            </CustomTabPanel >

            < CustomTabPanel value={value} index={2} >
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            sx={{
                                fontSize: '20px',
                                fontWeight: 500,
                                color: '#000',
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#858EA0',
                                mb: { xs: 1, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 400,
                            color: '#182A4E80',
                            mb: "30px",
                            lineHeight: '100%',
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>
                <Grid2 container spacing={1} sx={{ mt: 2 }}>
                    <Grid2 size={{ xs: 12, md: 12 }}>
                        <Milestone />
                    </Grid2>
                </Grid2>
            </CustomTabPanel >

            <CustomTabPanel value={value} index={3}>

                <ProgressKPIEngg />

                <Grid2 container columnSpacing={1.25} rowSpacing={{ xs: 2, md: 0 }} sx={{ mt: "10px", }}>
                    <Grid2 size={{ xs: 12, md: 7, lg: 7 }}>
                        <Card sx={{ boxShadow: 'none', borderRadius: 2, height: { xs: "auto", md: "450px" }, border: "1px solid #D8D8D8" }}>
                            <ScurveEngg />
                        </Card>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 5, lg: 5 }} >
                        <ApprovalWorkflowBottleneck />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1.25} rowSpacing={{ xs: 2, md: 1.25 }} sx={{ mt: { xs: 2, md: "10px" } }}>
                    <Grid2 size={{ xs: 12, md: 7, lg: 7 }}>
                        <DistributionofDocumentStatusByDepartment />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 5, lg: 5 }}>
                        <DocumentStatusBreakdown />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={4}>
                <ProgressKpiPM />
                <Grid2 container spacing={1.25} rowSpacing={{ xs: 2, md: 1.25 }} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <MachineRunHours />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <MachineStatus />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1.25} rowSpacing={{ xs: 2, md: 1.25 }} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <DeployedEquimentList />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <UpcomingEquipmentDeployment />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={5}>
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            sx={{
                                fontSize: '20px',
                                fontWeight: 500,
                                color: '#000',
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#858EA0',
                                mb: { xs: 1, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 400,
                            color: '#182A4E80',
                            mb: "30px",
                            lineHeight: '100%',
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>
                <Grid2 container spacing={1.25} sx={{}}>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <ManpowerPlanActual />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 8 }}>
                        <ManpowerShortfall />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 12 }}>
                        <UpcomgManpowerRequirement />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "730px" }}>
                        <ManpowerHistogram />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "655px" }}>
                        <ManpowerProductivity />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>

            </CustomTabPanel>
        </>
    );
};

export default ScheduleMonitoringTracking;
